import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import EarnVia from '../components/earnVia/EarnVia'
import { DEFAULT_CONTAINER_STATE } from '../constants/containerStates'
import { CUSTOM_BRAND_ID } from '../constants/pointsExchange'
import {
  changeEarnViaState,
  connectSocialAccount,
  getStats,
  getUGC,
  getUsernameByTID
} from '../store/actions/earnVia'
import { changeKYCState } from '../store/actions/kyc'
import { KYC_PROFILE_DISPATCH } from '../store/reducers/account/kyc'
import { EARN_VIA_PROFILE_DISPATCH } from '../store/reducers/earnVia/earnVia'
import {
  selectEarnViaProfile,
  selectKycProfile,
  selectMainProfile,
  selectTokenProfile
} from '../store/selectors/common'
import { isKycIncomplete } from '../util/kyc.helpers'
import { extractMembershipNumber } from '../util/pointsExchange.helpers'

const EarnViaContainer = () => {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const tokenProfile = useSelector(selectTokenProfile)
  const mainProfile = useSelector(selectMainProfile)
  const kycProfile = useSelector(selectKycProfile)
  const earnViaProfile = useSelector(selectEarnViaProfile)

  const connectedXAccount = extractMembershipNumber(
    mainProfile.exchangeMemberships,
    { brandId: CUSTOM_BRAND_ID.X }
  )

  useEffect(() => {
    if (connectedXAccount) {
      dispatch(getUGC())
      dispatch(getStats())
      dispatch(getUsernameByTID(connectedXAccount))
    }
    return () => {
      dispatch(changeEarnViaState(EARN_VIA_PROFILE_DISPATCH.CHANNEL_NAME, ''))
      dispatch(changeEarnViaState(EARN_VIA_PROFILE_DISPATCH.ERROR, {}))
    }
  }, [connectedXAccount])

  const handleCheckReq = () => {
    dispatch(
      changeKYCState(KYC_PROFILE_DISPATCH.POPUP_STATE, {
        id: DEFAULT_CONTAINER_STATE.FEATURE_LOCKED
      })
    )
  }

  const handleConnectSocial = (brandId) => {
    dispatch(connectSocialAccount(brandId))
  }

  return (
    <EarnVia
      t={t}
      earnViaProfile={earnViaProfile}
      symbol={tokenProfile.symbol}
      reqNotMet={isKycIncomplete({
        status: kycProfile.status
      })}
      onCheckReq={handleCheckReq}
      mainProfile={mainProfile}
      onConnectSocial={handleConnectSocial}
      connected={connectedXAccount}
    />
  )
}

export default EarnViaContainer
